const GOLD = '#f1ab2a'
const RED = '#e01f26'
const DARKRED = '#8f1418'

// Comic-burst polygon: alternating outer/inner radii around a center.
function burstPoints(
	cx: number,
	cy: number,
	spikes: number,
	rOuter: number,
	rInner: number,
	rotDeg = 0,
) {
	const points: string[] = []
	const total = spikes * 2
	for (let i = 0; i < total; i++) {
		const r = i % 2 === 0 ? rOuter : rInner
		const ang = (Math.PI / spikes) * i + (rotDeg * Math.PI) / 180 - Math.PI / 2
		points.push(
			`${(cx + r * Math.cos(ang)).toFixed(1)},${(cy + r * Math.sin(ang)).toFixed(1)}`,
		)
	}
	return points.join(' ')
}

/**
 * A colorful comic-book "NEW" starburst badge (red + gold). Reusable anywhere
 * on the site to flag something new — drop it next to a heading, card, or nav
 * item. Purely decorative (aria-hidden); pair with an sr-only label if the
 * "new" status needs to be announced to screen readers.
 */
export function NewBadge({
	size = 24,
	className,
}: {
	size?: number
	className?: string
}) {
	return (
		<svg
			viewBox="0 0 100 100"
			width={size}
			height={size}
			className={className}
			aria-hidden="true"
			focusable="false"
		>
			<polygon
				points={burstPoints(50, 50, 12, 48, 31, 4)}
				fill={RED}
				stroke={GOLD}
				strokeWidth={4}
				strokeLinejoin="round"
			/>
			<text
				x={50}
				y={50}
				transform="rotate(-8 50 50)"
				textAnchor="middle"
				dominantBaseline="central"
				fontFamily="Arial Black, Arial, sans-serif"
				fontWeight={900}
				fontSize={30}
				fill="#fff"
				stroke={DARKRED}
				strokeWidth={1}
				paintOrder="stroke"
			>
				NEW
			</text>
		</svg>
	)
}
